import { Button, Stack, Typography } from '@mui/material';
import TessellModal from 'common/custom-components/lib/components/TessellModal';
import OtpModal from '../OtpModal';
import useUpdateOngoingTenantIssue, {
  TENANT_ONGOING_ISSUE_FORM_UPDATE_IDENTIFIERS,
} from './useUpdateOngoingTenantIssue';
import { OTP_TYPE } from 'constants/otpType';
import { TenantType } from 'customers/tenants-common-view/lib/schema/Tenant.types';
import TessellInput from 'common/custom-components/lib/components/TessellInput';
import { tenantOngoingIssueUpdateModalClasses } from './styles';
import { getUpdateOrAddTitleForOngoingIssueModal } from './helpers';

interface TenantOngoingIssueUpdateModalProps {
  open: boolean;
  setOpen: any;
  selectedTenant: TenantType;
  onSuccess: () => void;
}

export const TenantOngoingIssueUpdateModal = (
  props: TenantOngoingIssueUpdateModalProps,
) => {
  const { open, setOpen, selectedTenant, onSuccess } = props;
  const {
    step,
    openOTP,
    setOpenOTP,
    sendOTPIsLoading,
    onSubmit,
    form,
    updateForm,
    updateOngoingIssueIsLoading,
    clearIssue,
    disableNext,
    disableClear,
    isNoteValid,
  } = useUpdateOngoingTenantIssue({ selectedTenant, onSuccess });

  const classes = tenantOngoingIssueUpdateModalClasses(isNoteValid);

  const onClose = () => {
    setOpen(false);
  };

  const DialogTitle = () => (
    <Stack>{getUpdateOrAddTitleForOngoingIssueModal(selectedTenant)}</Stack>
  );

  const DialogActions = () => {
    return (
      <Stack sx={classes.actionsContainer}>
        <Button
          variant="contained"
          size="small"
          sx={classes.actionButton}
          onClick={() => {
            onClose();
            clearIssue();
            setOpenOTP(true);
          }}
          disabled={disableClear}
        >
          Clear Issue
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onClose();
            setOpenOTP(true);
          }}
          sx={classes.actionButton}
          disabled={disableNext}
        >
          Next
        </Button>
      </Stack>
    );
  };

  const DialogContent = () => {
    return (
      <Stack sx={classes.contentContainer}>
        <Stack sx={classes.inputsContainer}>
          <Stack>
            <TessellInput
              label="Ongoing Issue"
              size="small"
              value={form?.[TENANT_ONGOING_ISSUE_FORM_UPDATE_IDENTIFIERS.ISSUE]}
              onChange={(e) =>
                updateForm(
                  TENANT_ONGOING_ISSUE_FORM_UPDATE_IDENTIFIERS.ISSUE,
                  e?.target?.value,
                )
              }
              multiline
              mt={0}
              mb={0.5}
              warn={!isNoteValid}
              color="warning"
              sx={classes.issueField}
            />
            {!isNoteValid && (
              <Typography sx={classes.errorWarningText}>
                Minimum 50 Characters
              </Typography>
            )}
          </Stack>
          <TessellInput
            label="Related Link"
            size="small"
            value={form?.[TENANT_ONGOING_ISSUE_FORM_UPDATE_IDENTIFIERS.LINK]}
            onChange={(e) =>
              updateForm(
                TENANT_ONGOING_ISSUE_FORM_UPDATE_IDENTIFIERS.LINK,
                e?.target?.value,
              )
            }
            placeholder={'Jira/Slack Link'}
          />
        </Stack>
      </Stack>
    );
  };

  const renderFunctions = {
    title: DialogTitle,
    content: DialogContent,
    actions: DialogActions,
  };

  const customStyles = {
    title: {},
    content: {},
    actions: {},
  };

  return (
    <>
      <TessellModal
        customStyles={customStyles}
        renderFunctions={renderFunctions}
        maxWidth="sm"
        open={open}
        onClose={onClose}
      />
      <OtpModal
        open={openOTP}
        setOpen={setOpenOTP}
        title={`Update Ongoing Issue for ${selectedTenant?.pgSource}`}
        onSubmit={(val) => {
          onSubmit(val);
        }}
        isSubmitting={
          step === 1 ? sendOTPIsLoading : updateOngoingIssueIsLoading
        }
        otpUser="Ops admin"
        step={step}
        reasonHeading="Enter reason for updating ongoing issue."
        otpType={OTP_TYPE.TENANT_ONGOING_ISSUE}
      />
    </>
  );
};
